<template>
  <lu-vbox lu-flex-wrap lu-vcenter class='vpad-in-20' style='padding: 15px;color: black;'>
        <lu-hbox lu-vcenter >
          <lu-item lu-flex style='width:220px;'>{{ $t('Settings Book') }} : </lu-item>

        </lu-hbox>
  </lu-vbox>
</template>

<script>
import { LuHbox, LuVbox, LuItem } from 'lusis-ui'

export default {
  name: 'SettingsLot',
  props: [ 'panelId' ],
  components: { LuHbox, LuVbox, LuItem },
  data: function () {
    return {
      lotsMios: 'mios'
    }
  },
  methods: {
    // onChangeTypeLot: function (val) {
    //   this.$store.dispatch('settingsMonitor/changeOptionSetting', panel)
    // }
  }
}
</script>

<style lang='scss'>


</style>